export { terminalUi } from './lib/terminal-ui-plugin.tsx';
